import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import ProductList from "pages/_components/product/List";
import { bool } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import ExpirationPaymentItem from "./ExpirationAgendaItem";

const ExpirationAgendaList = ({ isDesktop }) => {
    const hasMoreData = false;
    const { debts, fetching } = useSelector((state) => state.servicePayments);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(servicePaymentsActions.getDebts());
    }, [dispatch]);

    if (!debts?.length && !fetching) {
        return (
            <div className="box info service-payments__no-data">
                <Image src="images/information_fill.svg" /> <I18n id="payments.service.noPending" />
            </div>
        );
    }

    return (
        <ProductList
            fetchingWithPreviousData
            fetching={fetching}
            items={debts || []}
            noDataText="global.no.results"
            noFiltersDataText="debin.global.no.results"
            renderItem={(item) => (
                <GridTable.Container
                    key={`pending-payment-item-${item.hash}`}
                    renderAs={Link}
                    to={`/servicePayments/detail/${item.serviceId}/${item.hash}`}>
                    <ExpirationPaymentItem paymentItem={item} isDesktop={isDesktop} />
                </GridTable.Container>
            )}>
            {(listItem) => (
                <GridTable className="payment-details-list">
                    {listItem}
                    {hasMoreData && (
                        <Button
                            bsStyle="link"
                            // onClick={() => fetchMoreTransactions(latestPageNumber, filterThirdParties)}
                            image="images/figma/icon/arrow.svg"
                            label="global.showMore"
                        />
                    )}
                </GridTable>
            )}
        </ProductList>
    );
};

ExpirationAgendaList.propTypes = {
    isDesktop: bool.isRequired,
};

export default ExpirationAgendaList;
